import { FC } from 'react'
import { Participant as ParticipantType } from 'src/app/types'
import BadgeCount from '../InteractiveBadge/BadgeCount'

type ParticipantProps = {
  screenName: ParticipantType['screenName']
  badges: ParticipantType['badges']
}

const Participant: FC<ParticipantProps> = ({ screenName, badges }) => {
  return (
    <>
      <p className="font-[510]">{screenName}</p>
      <div className="inline-flex content-center">
        {badges.map(({ name, count }) => (
          <BadgeCount
            key={name}
            name={name}
            count={count}
            isOpen={false}
            clickable={false}
          />
        ))}
      </div>
    </>
  )
}

export default Participant
